<template>
  <v-dialog v-model="dialog" width="800">
    <v-card>
      <v-card-title class="text-h5 primary white--text d-flex flex-nowrap justify-space-between align-center">
        {{ $t('guide.firstStepTitle') }}
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <p class="mb-1">{{ $t('step') }} {{ step }} {{ $t('of') }} {{ maxSteps }}</p>
        <div class="black--text text-body-1 mb-2" v-show="step === 1">
          <h6 class="text-h6 mb-3">{{ $t('guide.dashboard.userManagement') }}</h6>
          <p>{{ $t('guide.dashboard.userManagementDescription') }}</p>
          <ul>
            <li>{{ $t('guide.dashboard.listUser') }}</li>
            <li>{{ $t('guide.dashboard.addUser') }}</li>
            <li>{{ $t('guide.dashboard.managePermission') }}</li>
          </ul>
        </div>
        <div class="black--text text-body-1 mb-2" v-show="step === 2">
          <h6 class="text-h6 mb-3">{{ $t('guide.dashboard.farmManagement') }}</h6>
          <p>{{ $t('guide.dashboard.farmManagementDescription') }}</p>
          <ul>
            <li>{{ $t('guide.dashboard.listFarm') }}</li>
            <li>{{ $t('guide.dashboard.addFarm') }}</li>
          </ul>
        </div>
        <div class="black--text text-body-1 mb-2" v-show="step === 3">
          <h6 class="text-h6 mb-3">{{ $t('guide.dashboard.title') }}</h6>
          <p>{{ $t('guide.dashboard.description') }}</p>
        </div>
        <v-checkbox v-model="hideDialogInFuture" :label="$t('guide.dontShowAgain')"></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="closeDialog">{{ $t('dueDiligence.close') }}</v-btn>
        <v-btn depressed color="primary" v-show="step > 1" @click="onPrev">{{ $t('deforestation.back') }}</v-btn>
        <v-btn :to="{ name: 'Users' }" depressed color="primary" v-show="step == 1">{{ $t('guide.dashboard.userManagement') }}</v-btn>
        <v-btn :to="{ name: 'Farms' }" depressed color="primary" v-show="step == 2">{{ $t('guide.dashboard.farmManagement') }}</v-btn>
        <v-btn depressed color="primary" v-show="step < maxSteps" @click="onNext">{{ $t('deforestation.next') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: localStorage.getItem('hideDashboardGuide') !== 'true',
      step: 1,
      maxSteps: 3,
      hideDialogInFuture: false,
    };
  },

  methods: {
    closeDialog() {
      if (this.hideDialogInFuture) {
        localStorage.setItem('hideDashboardGuide', 'true');
      }
      this.dialog = false;
    },
    onNext() {
      if (this.step < this.maxSteps) {
        this.step += 1;
      }
    },
    onPrev() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
  },
};
</script>

<style scoped>
li {
  margin-bottom: 4px;
}
</style>
